/**
 * Tenant-slug URL helpers. The authenticated app lives under `/t/<tenantCode>/…`
 * (the app router's basename); auth + company pages stay at the root.
 */

/** Build an authed app URL under the tenant slug. */
export function appUrl(tenantCode: string, subPath = "/dashboard"): string {
  const s = subPath.startsWith("/") ? subPath : `/${subPath}`;
  return `/t/${tenantCode}${s}`;
}

/** True when a path is one of the root-level auth / company pages (no tenant slug). */
const PUBLIC_PREFIXES = [
  "/login",
  "/signup",
  "/verify-email",
  "/forgot-password",
  "/reset-password",
  "/accept-invitation",
  "/select-company",
  "/onboarding",
];
export function isPublicPath(pathname: string): boolean {
  return PUBLIC_PREFIXES.some((p) => pathname === p || pathname.startsWith(`${p}/`));
}

/** Strip a leading `/t/<slug>` from a pathname, returning the app sub-path. */
export function stripTenantPrefix(pathname: string): string {
  const stripped = pathname.replace(/^\/t\/[^/]+/, "");
  return stripped === "" ? "/" : stripped;
}

/**
 * Full-page navigation INTO the tenant app (or to a fallback when tenant-less).
 * Used at router boundaries — login, company switch, onboarding — so the root
 * resolver re-mounts the basename'd app router for the (possibly new) tenant.
 */
export function enterApp(tenantCode: string | null | undefined, subPath = "/dashboard"): void {
  window.location.assign(tenantCode ? appUrl(tenantCode, subPath) : "/onboarding");
}
